import { GetServerSideProps } from 'next';
import { getSeoMetaTags, getSeoBlockContent, getCategoryData } from 'utils/common.utils';
import EyewearSelectionPage from 'components/EyewearSelectionPage/EyewearSelectionPage';
import { CategoryBannerProps } from 'components/CategoryBanner/CategoryBanner';
import { CategoryData } from 'types/category';

export default EyewearSelectionPage;

export const getServerSideProps: GetServerSideProps = async ({ locale, params }) => {
  if (!params || !params.category) {
    return {
      notFound: true
    };
  }

  const pageSlug = 'eyewear-selection/' + params.category;

  const seoMetaTags = await getSeoMetaTags(pageSlug, locale);

  
  const categoryData = await getCategoryData('eyewear-selection', locale, pageSlug);
  if (!categoryData || !categoryData.title)  {
    return {
     redirect: {
      destination: '/eyewear-selection',
      permanent: false
     }
    };
  }
  
  const categoryBannerProps: CategoryBannerProps = {
    title: categoryData.title,
    description: '<h1>' + categoryData.title + '</h1>' + categoryData.content,
    imageSrc: categoryData.bannerImage,
    imageAlt: categoryData.bannerImageAlt
  }



  const seoBlock = await getSeoBlockContent(pageSlug, locale);
  return {
    props: {
      seoMetaTags,
      categoryBannerProps,
      params,
      seoBlock,
      pageData: categoryData
    }
  };
};
